<template>
  <blockquote>
    <q>{{testimonial.quote}}</q>
    <div>- {{testimonial.attribution}}</div>
  </blockquote>
</template>

<script>
export default {
  name: 'Testimonial',
  props: ['testimonial']
}
</script>

<style lang="less" scoped>
blockquote {
  margin: 3em 0;
  font-family: 'Caveat', cursive;

  q {
    font-weight: bold;
    font-size: 3em;
  }

  div {
    font-size: 1.5em;
    text-align: right;
  }
}
</style>
